<script>
import {mapActions, mapState} from "pinia";
import {editProposalStore} from "@/store/editProposalStore";
import Dialog from "primevue/dialog";

export default {
  name: "ProposalAlmostPublishModal",
  components: {
    Dialog
  },
  computed: {
    ...mapState(editProposalStore, [
      'almostPublishModalState'
    ]),
    modalState: {
      get() {
        return this.almostPublishModalState;
      },
      set() {
        this.closeModal();
      },
    },
  },
  methods: {
    ...mapActions(editProposalStore, [
      'toggleAlmostPublishModal'
    ]),
    closeModal() {
      this.toggleAlmostPublishModal();
    }
  }
}
</script>

<template>
  <Dialog v-model:visible="modalState"
          class="proposal-almost-publish-modal"
          modal
          :header="$t('proposal.almostPublishModal.title')"
  >
    <div class="proposal-almost-publish-modal__body">
      {{$t('proposal.almostPublishModal.p1')}}
    </div>
    <template #footer>
      <button class="p-dialog-primary-btn"
              @click="closeModal"
      >
        {{$t('common.buttons.close')}}
      </button>
    </template>
  </Dialog>
</template>

<style lang="scss">
.proposal-almost-publish-modal {
  &__body {
    padding: 15px;
  }

  .p-dialog-content {
    padding: 15px;
  }
}

</style>